import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitledPageComponent } from 'src/app/shared/components/titled-page/titled-page.component';

@Component({
  selector: 'app-issues',
  standalone: true,
  imports: [RouterOutlet, TitledPageComponent],
  templateUrl: './issues.component.html',
  styleUrl: './issues.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuesComponent {}
